import axios from "@/config/axiosConfig";

export const importFromCustomerData = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();

      return axios.post("/import-from-customer/data", data, 
        { params: { companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
          return response;
        }).catch((error) => {
          console.error(error);
          throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};
